// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Modern Form Component Styles
 */

/* Form Field */
.form-field {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin-bottom: var(--space-6);
}

.form-field__label {
  font-size: var(--text-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--neutral-700);
  margin: 0;
}

.form-field__required {
  color: var(--error-500);
  margin-left: var(--space-1);
}

.form-field__hint {
  font-size: var(--text-xs);
  color: var(--neutral-500);
  margin: 0;
}

.form-field__error {
  font-size: var(--text-xs);
  color: var(--error-500);
  margin: 0;
  display: flex;
  align-items: center;
  gap: var(--space-1);
}

.form-field__error::before {
  content: '⚠';
  font-size: var(--text-xs);
}

/* Modern Input */
.modern-input {
  width: 100%;
  padding: var(--space-3) var(--space-4);
  border: 2px solid var(--neutral-200);
  border-radius: var(--radius-lg);
  font-size: var(--text-base);
  font-family: var(--font-family-sans);
  background: white;
  color: var(--neutral-900);
  transition: all var(--transition-base);
  outline: none;
}

.modern-input:focus {
  border-color: #0D3B66;
  box-shadow: 0 0 0 3px rgba(13, 59, 102, 0.4);
}

.modern-input:disabled {
  background: var(--neutral-100);
  color: var(--neutral-500);
  cursor: not-allowed;
}

.modern-input--error {
  border-color: var(--error-500);
}

.modern-input--error:focus {
  border-color: var(--error-500);
  box-shadow: 0 0 0 3px var(--error-100);
}

.modern-input::placeholder {
  color: var(--neutral-400);
}

/* Modern Textarea */
.modern-textarea {
  width: 100%;
  padding: var(--space-3) var(--space-4);
  border: 2px solid var(--neutral-200);
  border-radius: var(--radius-lg);
  font-size: var(--text-base);
  font-family: var(--font-family-sans);
  background: white;
  color: var(--neutral-900);
  transition: all var(--transition-base);
  outline: none;
  resize: vertical;
  min-height: 100px;
}

.modern-textarea:focus {
  border-color: #0D3B66;
  box-shadow: 0 0 0 3px rgba(13, 59, 102, 0.4);
}

.modern-textarea:disabled {
  background: var(--neutral-100);
  color: var(--neutral-500);
  cursor: not-allowed;
}

.modern-textarea--error {
  border-color: var(--error-500);
}

.modern-textarea--error:focus {
  border-color: var(--error-500);
  box-shadow: 0 0 0 3px var(--error-100);
}

.modern-textarea::placeholder {
  color: var(--neutral-400);
}

/* Modern Select */
.modern-select {
  width: 100%;
  padding: var(--space-3) var(--space-4);
  border: 2px solid var(--neutral-200);
  border-radius: var(--radius-lg);
  font-size: var(--text-base);
  font-family: var(--font-family-sans);
  background: white;
  color: var(--neutral-900);
  transition: all var(--transition-base);
  outline: none;
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right var(--space-3) center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: var(--space-10);
}

.modern-select:focus {
  border-color: var(--primary-600);
  box-shadow: 0 0 0 3px var(--primary-100);
}

.modern-select:disabled {
  background: var(--neutral-100);
  color: var(--neutral-500);
  cursor: not-allowed;
}

.modern-select--error {
  border-color: var(--error-500);
}

.modern-select--error:focus {
  border-color: var(--error-500);
  box-shadow: 0 0 0 3px var(--error-100);
}

/* Modern Checkbox */
.modern-checkbox {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.modern-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.modern-checkbox__checkmark {
  width: 20px;
  height: 20px;
  border: 2px solid var(--neutral-300);
  border-radius: var(--radius-sm);
  background: white;
  position: relative;
  transition: all var(--transition-base);
  flex-shrink: 0;
}

.modern-checkbox input:checked~.modern-checkbox__checkmark {
  background: var(--primary-600);
  border-color: var(--primary-600);
}

.modern-checkbox input:checked~.modern-checkbox__checkmark::after {
  content: '';
  position: absolute;
  left: 6px;
  top: 2px;
  width: 6px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.modern-checkbox__label {
  font-size: var(--text-sm);
  color: var(--neutral-700);
  font-weight: var(--font-weight-medium);
}

.modern-checkbox--error .modern-checkbox__checkmark {
  border-color: var(--error-500);
}

.modern-checkbox--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Modern Radio */
.modern-radio {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.modern-radio input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.modern-radio__checkmark {
  width: 20px;
  height: 20px;
  border: 2px solid var(--neutral-300);
  border-radius: var(--radius-full);
  background: white;
  position: relative;
  transition: all var(--transition-base);
  flex-shrink: 0;
}

.modern-radio input:checked~.modern-radio__checkmark {
  background: var(--primary-600);
  border-color: var(--primary-600);
}

.modern-radio input:checked~.modern-radio__checkmark::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  width: 8px;
  height: 8px;
  border-radius: var(--radius-full);
  background: white;
  transform: translate(-50%, -50%);
}

.modern-radio__label {
  font-size: var(--text-sm);
  color: var(--neutral-700);
  font-weight: var(--font-weight-medium);
}

.modern-radio--error .modern-radio__checkmark {
  border-color: var(--error-500);
}

.modern-radio--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Modern Button */
.modern-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-6);
  border: 2px solid transparent;
  border-radius: var(--radius-lg);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-semibold);
  font-family: var(--font-family-sans);
  text-decoration: none;
  cursor: pointer;
  transition: all var(--transition-base);
  outline: none;
  position: relative;
  overflow: hidden;
}

.modern-button:focus {
  outline: 2px solid var(--primary-600);
  outline-offset: 2px;
}

.modern-button__content {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.modern-button__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--text-base);
}

.modern-button__spinner {
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: var(--radius-full);
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* Button Variants */
.modern-button--primary {
  background: linear-gradient(135deg, var(--primary-500), var(--primary-600));
  color: white;
  border-color: var(--primary-600);
}

.modern-button--primary:hover:not(:disabled) {
  background: linear-gradient(135deg, var(--primary-600), var(--primary-700));
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.modern-button--secondary {
  background: white;
  color: var(--primary-600);
  border-color: var(--primary-200);
}

.modern-button--secondary:hover:not(:disabled) {
  background: var(--primary-50);
  border-color: var(--primary-300);
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

.modern-button--success {
  background: linear-gradient(135deg, var(--success-500), var(--success-600));
  color: white;
  border-color: var(--success-500);
}

.modern-button--success:hover:not(:disabled) {
  background: linear-gradient(135deg, var(--success-600), var(--success-700));
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.modern-button--warning {
  background: linear-gradient(135deg, var(--warning-500), var(--warning-600));
  color: white;
  border-color: var(--warning-500);
}

.modern-button--warning:hover:not(:disabled) {
  background: linear-gradient(135deg, var(--warning-600), var(--warning-700));
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.modern-button--error {
  background: linear-gradient(135deg, var(--error-500), var(--error-600));
  color: white;
  border-color: var(--error-500);
}

.modern-button--error:hover:not(:disabled) {
  background: linear-gradient(135deg, var(--error-600), var(--error-700));
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.modern-button--outline {
  background: transparent;
  color: var(--neutral-700);
  border-color: var(--neutral-300);
}

.modern-button--outline:hover:not(:disabled) {
  background: var(--neutral-50);
  border-color: var(--neutral-400);
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

.modern-button--ghost {
  background: transparent;
  color: var(--neutral-700);
  border-color: transparent;
}

.modern-button--ghost:hover:not(:disabled) {
  background: var(--neutral-100);
  transform: translateY(-1px);
}

/* Button Sizes */
.modern-button--sm {
  padding: var(--space-2) var(--space-4);
  font-size: var(--text-xs);
}

.modern-button--md {
  padding: var(--space-3) var(--space-6);
  font-size: var(--text-sm);
}

.modern-button--lg {
  padding: var(--space-4) var(--space-8);
  font-size: var(--text-base);
}

.modern-button--xl {
  padding: var(--space-5) var(--space-10);
  font-size: var(--text-lg);
}

/* Button States */
.modern-button--disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

.modern-button--loading {
  cursor: not-allowed;
}

/* Form Components */
.modern-form {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

/* Form Groups - Now using global styles from design-system.css */

/* Responsive Design */
@media (max-width: 768px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  .modern-button--lg {
    padding: var(--space-3) var(--space-6);
    font-size: var(--text-sm);
  }

  .modern-button--xl {
    padding: var(--space-4) var(--space-8);
    font-size: var(--text-base);
  }
}

/* Dark Mode Support */
@media (prefers-color-scheme: dark) {

  .modern-input,
  .modern-textarea,
  .modern-select {
    background: var(--neutral-800);
    border-color: var(--neutral-600);
    color: var(--neutral-100);
  }

  .modern-input:focus,
  .modern-textarea:focus,
  .modern-select:focus {
    border-color: var(--primary-400);
    box-shadow: 0 0 0 3px var(--primary-900);
  }

  .modern-checkbox__checkmark,
  .modern-radio__checkmark {
    background: var(--neutral-800);
    border-color: var(--neutral-600);
  }

  .form-field__label {
    color: var(--neutral-300);
  }

  .form-field__hint {
    color: var(--neutral-400);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/ModernForm.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,sCAAsC;EACtC,oCAAoC;EACpC,+BAA+B;EAC/B,2BAA2B;EAC3B,oCAAoC;EACpC,iBAAiB;EACjB,yBAAyB;EACzB,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,sCAAsC;EACtC,oCAAoC;EACpC,+BAA+B;EAC/B,2BAA2B;EAC3B,oCAAoC;EACpC,iBAAiB;EACjB,yBAAyB;EACzB,sCAAsC;EACtC,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,sCAAsC;EACtC,oCAAoC;EACpC,+BAA+B;EAC/B,2BAA2B;EAC3B,oCAAoC;EACpC,iBAAiB;EACjB,yBAAyB;EACzB,sCAAsC;EACtC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,yDAAmP;EACnP,gDAAgD;EAChD,4BAA4B;EAC5B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,6BAA6B;EAC7B,+BAA+B;EAC/B,yBAAyB;EACzB,wCAAwC;EACxC,oCAAoC;EACpC,qBAAqB;EACrB,eAAe;EACf,sCAAsC;EACtC,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kCAAkC;EAClC,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,oBAAoB;AACpB;EACE,2EAA2E;EAC3E,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,2EAA2E;EAC3E,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,2EAA2E;EAC3E,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,2EAA2E;EAC3E,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,2EAA2E;EAC3E,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,2EAA2E;EAC3E,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,uEAAuE;EACvE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,uEAAuE;EACvE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,iEAAiE;;AAEjE,sBAAsB;AACtB;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sCAAsC;IACtC,yBAAyB;EAC3B;;EAEA;IACE,sCAAsC;IACtC,2BAA2B;EAC7B;AACF;;AAEA,sBAAsB;AACtB;;EAEE;;;IAGE,8BAA8B;IAC9B,gCAAgC;IAChC,yBAAyB;EAC3B;;EAEA;;;IAGE,gCAAgC;IAChC,wCAAwC;EAC1C;;EAEA;;IAEE,8BAA8B;IAC9B,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/**\n * Modern Form Component Styles\n */\n\n/* Form Field */\n.form-field {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n  margin-bottom: var(--space-6);\n}\n\n.form-field__label {\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--neutral-700);\n  margin: 0;\n}\n\n.form-field__required {\n  color: var(--error-500);\n  margin-left: var(--space-1);\n}\n\n.form-field__hint {\n  font-size: var(--text-xs);\n  color: var(--neutral-500);\n  margin: 0;\n}\n\n.form-field__error {\n  font-size: var(--text-xs);\n  color: var(--error-500);\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: var(--space-1);\n}\n\n.form-field__error::before {\n  content: '⚠';\n  font-size: var(--text-xs);\n}\n\n/* Modern Input */\n.modern-input {\n  width: 100%;\n  padding: var(--space-3) var(--space-4);\n  border: 2px solid var(--neutral-200);\n  border-radius: var(--radius-lg);\n  font-size: var(--text-base);\n  font-family: var(--font-family-sans);\n  background: white;\n  color: var(--neutral-900);\n  transition: all var(--transition-base);\n  outline: none;\n}\n\n.modern-input:focus {\n  border-color: #0D3B66;\n  box-shadow: 0 0 0 3px rgba(13, 59, 102, 0.4);\n}\n\n.modern-input:disabled {\n  background: var(--neutral-100);\n  color: var(--neutral-500);\n  cursor: not-allowed;\n}\n\n.modern-input--error {\n  border-color: var(--error-500);\n}\n\n.modern-input--error:focus {\n  border-color: var(--error-500);\n  box-shadow: 0 0 0 3px var(--error-100);\n}\n\n.modern-input::placeholder {\n  color: var(--neutral-400);\n}\n\n/* Modern Textarea */\n.modern-textarea {\n  width: 100%;\n  padding: var(--space-3) var(--space-4);\n  border: 2px solid var(--neutral-200);\n  border-radius: var(--radius-lg);\n  font-size: var(--text-base);\n  font-family: var(--font-family-sans);\n  background: white;\n  color: var(--neutral-900);\n  transition: all var(--transition-base);\n  outline: none;\n  resize: vertical;\n  min-height: 100px;\n}\n\n.modern-textarea:focus {\n  border-color: #0D3B66;\n  box-shadow: 0 0 0 3px rgba(13, 59, 102, 0.4);\n}\n\n.modern-textarea:disabled {\n  background: var(--neutral-100);\n  color: var(--neutral-500);\n  cursor: not-allowed;\n}\n\n.modern-textarea--error {\n  border-color: var(--error-500);\n}\n\n.modern-textarea--error:focus {\n  border-color: var(--error-500);\n  box-shadow: 0 0 0 3px var(--error-100);\n}\n\n.modern-textarea::placeholder {\n  color: var(--neutral-400);\n}\n\n/* Modern Select */\n.modern-select {\n  width: 100%;\n  padding: var(--space-3) var(--space-4);\n  border: 2px solid var(--neutral-200);\n  border-radius: var(--radius-lg);\n  font-size: var(--text-base);\n  font-family: var(--font-family-sans);\n  background: white;\n  color: var(--neutral-900);\n  transition: all var(--transition-base);\n  outline: none;\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n  background-position: right var(--space-3) center;\n  background-repeat: no-repeat;\n  background-size: 1.5em 1.5em;\n  padding-right: var(--space-10);\n}\n\n.modern-select:focus {\n  border-color: var(--primary-600);\n  box-shadow: 0 0 0 3px var(--primary-100);\n}\n\n.modern-select:disabled {\n  background: var(--neutral-100);\n  color: var(--neutral-500);\n  cursor: not-allowed;\n}\n\n.modern-select--error {\n  border-color: var(--error-500);\n}\n\n.modern-select--error:focus {\n  border-color: var(--error-500);\n  box-shadow: 0 0 0 3px var(--error-100);\n}\n\n/* Modern Checkbox */\n.modern-checkbox {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  cursor: pointer;\n  user-select: none;\n}\n\n.modern-checkbox input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.modern-checkbox__checkmark {\n  width: 20px;\n  height: 20px;\n  border: 2px solid var(--neutral-300);\n  border-radius: var(--radius-sm);\n  background: white;\n  position: relative;\n  transition: all var(--transition-base);\n  flex-shrink: 0;\n}\n\n.modern-checkbox input:checked~.modern-checkbox__checkmark {\n  background: var(--primary-600);\n  border-color: var(--primary-600);\n}\n\n.modern-checkbox input:checked~.modern-checkbox__checkmark::after {\n  content: '';\n  position: absolute;\n  left: 6px;\n  top: 2px;\n  width: 6px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n.modern-checkbox__label {\n  font-size: var(--text-sm);\n  color: var(--neutral-700);\n  font-weight: var(--font-weight-medium);\n}\n\n.modern-checkbox--error .modern-checkbox__checkmark {\n  border-color: var(--error-500);\n}\n\n.modern-checkbox--disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Modern Radio */\n.modern-radio {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  cursor: pointer;\n  user-select: none;\n}\n\n.modern-radio input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.modern-radio__checkmark {\n  width: 20px;\n  height: 20px;\n  border: 2px solid var(--neutral-300);\n  border-radius: var(--radius-full);\n  background: white;\n  position: relative;\n  transition: all var(--transition-base);\n  flex-shrink: 0;\n}\n\n.modern-radio input:checked~.modern-radio__checkmark {\n  background: var(--primary-600);\n  border-color: var(--primary-600);\n}\n\n.modern-radio input:checked~.modern-radio__checkmark::after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  width: 8px;\n  height: 8px;\n  border-radius: var(--radius-full);\n  background: white;\n  transform: translate(-50%, -50%);\n}\n\n.modern-radio__label {\n  font-size: var(--text-sm);\n  color: var(--neutral-700);\n  font-weight: var(--font-weight-medium);\n}\n\n.modern-radio--error .modern-radio__checkmark {\n  border-color: var(--error-500);\n}\n\n.modern-radio--disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Modern Button */\n.modern-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-2);\n  padding: var(--space-3) var(--space-6);\n  border: 2px solid transparent;\n  border-radius: var(--radius-lg);\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-semibold);\n  font-family: var(--font-family-sans);\n  text-decoration: none;\n  cursor: pointer;\n  transition: all var(--transition-base);\n  outline: none;\n  position: relative;\n  overflow: hidden;\n}\n\n.modern-button:focus {\n  outline: 2px solid var(--primary-600);\n  outline-offset: 2px;\n}\n\n.modern-button__content {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n}\n\n.modern-button__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--text-base);\n}\n\n.modern-button__spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid transparent;\n  border-top: 2px solid currentColor;\n  border-radius: var(--radius-full);\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Button Variants */\n.modern-button--primary {\n  background: linear-gradient(135deg, var(--primary-500), var(--primary-600));\n  color: white;\n  border-color: var(--primary-600);\n}\n\n.modern-button--primary:hover:not(:disabled) {\n  background: linear-gradient(135deg, var(--primary-600), var(--primary-700));\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.modern-button--secondary {\n  background: white;\n  color: var(--primary-600);\n  border-color: var(--primary-200);\n}\n\n.modern-button--secondary:hover:not(:disabled) {\n  background: var(--primary-50);\n  border-color: var(--primary-300);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n}\n\n.modern-button--success {\n  background: linear-gradient(135deg, var(--success-500), var(--success-600));\n  color: white;\n  border-color: var(--success-500);\n}\n\n.modern-button--success:hover:not(:disabled) {\n  background: linear-gradient(135deg, var(--success-600), var(--success-700));\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.modern-button--warning {\n  background: linear-gradient(135deg, var(--warning-500), var(--warning-600));\n  color: white;\n  border-color: var(--warning-500);\n}\n\n.modern-button--warning:hover:not(:disabled) {\n  background: linear-gradient(135deg, var(--warning-600), var(--warning-700));\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.modern-button--error {\n  background: linear-gradient(135deg, var(--error-500), var(--error-600));\n  color: white;\n  border-color: var(--error-500);\n}\n\n.modern-button--error:hover:not(:disabled) {\n  background: linear-gradient(135deg, var(--error-600), var(--error-700));\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.modern-button--outline {\n  background: transparent;\n  color: var(--neutral-700);\n  border-color: var(--neutral-300);\n}\n\n.modern-button--outline:hover:not(:disabled) {\n  background: var(--neutral-50);\n  border-color: var(--neutral-400);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n}\n\n.modern-button--ghost {\n  background: transparent;\n  color: var(--neutral-700);\n  border-color: transparent;\n}\n\n.modern-button--ghost:hover:not(:disabled) {\n  background: var(--neutral-100);\n  transform: translateY(-1px);\n}\n\n/* Button Sizes */\n.modern-button--sm {\n  padding: var(--space-2) var(--space-4);\n  font-size: var(--text-xs);\n}\n\n.modern-button--md {\n  padding: var(--space-3) var(--space-6);\n  font-size: var(--text-sm);\n}\n\n.modern-button--lg {\n  padding: var(--space-4) var(--space-8);\n  font-size: var(--text-base);\n}\n\n.modern-button--xl {\n  padding: var(--space-5) var(--space-10);\n  font-size: var(--text-lg);\n}\n\n/* Button States */\n.modern-button--disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none !important;\n  box-shadow: none !important;\n}\n\n.modern-button--loading {\n  cursor: not-allowed;\n}\n\n/* Form Components */\n.modern-form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-6);\n}\n\n/* Form Groups - Now using global styles from design-system.css */\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .modern-button--lg {\n    padding: var(--space-3) var(--space-6);\n    font-size: var(--text-sm);\n  }\n\n  .modern-button--xl {\n    padding: var(--space-4) var(--space-8);\n    font-size: var(--text-base);\n  }\n}\n\n/* Dark Mode Support */\n@media (prefers-color-scheme: dark) {\n\n  .modern-input,\n  .modern-textarea,\n  .modern-select {\n    background: var(--neutral-800);\n    border-color: var(--neutral-600);\n    color: var(--neutral-100);\n  }\n\n  .modern-input:focus,\n  .modern-textarea:focus,\n  .modern-select:focus {\n    border-color: var(--primary-400);\n    box-shadow: 0 0 0 3px var(--primary-900);\n  }\n\n  .modern-checkbox__checkmark,\n  .modern-radio__checkmark {\n    background: var(--neutral-800);\n    border-color: var(--neutral-600);\n  }\n\n  .form-field__label {\n    color: var(--neutral-300);\n  }\n\n  .form-field__hint {\n    color: var(--neutral-400);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
